import React from 'react'
import { Grid } from '@material-ui/core/'
import CardTemplate from '../CardTemplate'
import './index.scss'

const Mails = ({ emails, deleteTemplate, getTemplateById }) => {
  return (
    <Grid className='wrapperTemplatesCard'>
      {emails?.map(({ uuid, name, description, createdAt }) => (
        <CardTemplate
          getTemplateById={getTemplateById}
          deleteTemplate={deleteTemplate}
          key={uuid}
          uuid={uuid}
          name={name}
          date={createdAt}
        />
      ))}
    </Grid>
  )
}

export default Mails
